import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { NestResponsesProvider } from "../../../../shared/nestjs/nest-responses";
import { NestApiProvider } from "../../../../shared/nestjs/nest-api";
import { CertificationSf6Api } from "../../../../shared/nestjs/gd-integrated/services/certification-sf6";
import { Observable } from "rxjs/Observable";
import { PersonalNestApi } from "../../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../../providers/global-service/global-service";
import { StoragePathProvider } from "../../../../providers/storage-path/storage-path";
import { CameraNative } from "../../../../native/camera.native";
import { CameraOptions } from "@ionic-native/camera";
import { Platform } from "ionic-angular";
import { FileUploaderProvider, OptionsUploadWithHttp } from "../../../../providers/file-uploader/file-uploader";
import { FileOpener } from "@ionic-native/file-opener";
import { FileTransferObject, FileTransfer } from "@ionic-native/file-transfer";
import { FileDownloaderProvider } from "../../../../providers/file-downloader/file-downloader";
import saveAs from 'file-saver';
declare var cordova: any;

export interface UploadProfileOptions {
	image: any,
	bodies: any,
	userId: any,
	eventsWebView?: any,
	photoName?: string // kalau di web required
}
@Injectable()
export class ProfileCertificationtBloc {
  subscriptions: Array<Subscription> = [];

  constructor(
    public nestResponse: NestResponsesProvider,
    public nestApiProvider: NestApiProvider,
    public certificationSf6Api: CertificationSf6Api,
    public personalApi: PersonalNestApi,
    public globalService: GlobalServiceProvider,
    private storagePathProvider: StoragePathProvider,
    private cameraNative: CameraNative,
    private platform: Platform,
    private fileUploaderProvider: FileUploaderProvider,
    public fileOpener: FileOpener,
    public transfer: FileTransfer,
    private fileDownloaderProvider: FileDownloaderProvider, 
  ) { }

  // getHistory(payload: RequestBankGetHistoryDto): Promise<ResponsePaging<ResponseBankAccountGetHistoryDto>> {
  listing(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.certificationSf6Api.listing(payload)
          .subscribe((result) => {
            resolve(result.data)
          }, error => {
            reject(error);
          })
      )
    })
  }

  historyById(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.certificationSf6Api.historyById(payload)
          .subscribe((result) => {
            resolve(result.data)
          }, error => {
            reject(error);
          })
      )
    })
  }

  add(payload): Observable<any> {
    return this.certificationSf6Api.add(payload);
  }

  save(payload): Observable<any> {
    return this.certificationSf6Api.save(payload);
  }

  delete2(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.certificationSf6Api.delete(payload)
          .subscribe((result) => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  delete(payload): Observable<any> {
    console.log('>>- Delete', payload)
    return this.certificationSf6Api.delete(payload);
  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe);
  }

  formatDate() {
    let d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear(),
      hour = d.getHours(),
      minute = d.getMinutes(),
      sec = d.getSeconds();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day, hour, minute, sec].join('');
  }

  makeid() {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    for (let i = 0; i < 12; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  makeidsf6() {
    let text = '';
    const possible = '0123456789';
    for (let i = 0; i < 3; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  createFileName(SFGoAuth, isCamera: boolean, picture) {
    console.log('createFileName SFGoAuth', isCamera, picture)
    let result = isCamera ? 'EMPCTFCT_' + this.formatDate() + '_' +  SFGoAuth.userId + '_' + picture.substr(picture.lastIndexOf('/') + 1) : 'EMPCTFCT_' + this.formatDate() + '_' + SFGoAuth.userId + '_' + this.makeid().toString();
    
    // if (isCamera == false && !picture && !fileType) {
    //   result = 'EMPCTFCT' + SFGoAuth.empNo + this.formatDate() + this.makeidsf6().toString();
    // }

    // if (fileType) {
    //   console.log('FILETYPE', fileType)
    //   result = SFGoAuth.companyCode + '_FILE_' + this.formatDate() + '_' + SFGoAuth.userId + '_' + this.makeid().toString() + '.' + fileType; 
    // } else {
    //   console.log('!FILETYPE')
    //   result = isCamera ? 'EMPCTFCT_' + this.formatDate() + '_' +  SFGoAuth.userId + '_' + picture.substr(picture.lastIndexOf('/') + 1) : 'EMPCTFCT_' + this.formatDate() + '_' + SFGoAuth.userId + '_' + this.makeid().toString();
    // }
		return result;
  }

  getPersonal(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.personalApi.getPersonal(payload).subscribe(
        async (result) => {
          console.log('getPersonal', result)
          let resultData = await this.globalService.convertObjToCamelCase(result.data);
          console.log('resultData', resultData)
          resolve(resultData);
        }, error => {
          reject(error);
          console.log('getPersonal', error)
        }
      )
    })
  }

  async takePicture(isCamera: boolean) {
		if (this.platform.is('cordova')) {
			const cameraOption: CameraOptions = {
				sourceType: isCamera ? this.cameraNative.camera.PictureSourceType.CAMERA : this.cameraNative.camera.PictureSourceType.PHOTOLIBRARY
			}
			const camera = await this.cameraNative.getPicture(cameraOption)
			return camera.nativeURL;
		}
	}

  processWebImage(event) {
		return new Promise((resolve, reject) => {
			let name = event.target.files[0].name;
			let fileIMG = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
			let formatImage = name.split('.').pop();
			let res = formatImage.toLowerCase();

			if (fileIMG.indexOf(res) < 0) {
				reject('File type is invalid.')
			} else {
				const reader = new FileReader();
				reader.addEventListener('load', () => {
					resolve(reader.result);
				}, false);
				reader.readAsDataURL(event.target.files[0]);
			}
		})
  }

  uploadAttach(params: UploadProfileOptions) {
		return new Promise(async (resolve, reject) => {
			try {
        console.log('uploadAttach BLOC')
        const path = await this.storagePathProvider.getStorageProfileCustom(params.userId);
        console.log('path', path)
        
				const options: OptionsUploadWithHttp = {
					options: params.photoName || null,
					nativeURI: params.image,
					body: params.bodies,
					type: 'image',
					eventsWebview: params.eventsWebView || null
        }
        
				let result = await this.fileUploaderProvider.uploadWithHttp(options, path.urlUpload, false);
				console.log('result upload', result)
        result = result.data.SERVERFILE;

				resolve(result);
			} catch (error) {
				reject(error)
			}
		})
	}

  downloadAtch(certificationPath, filename) {
    console.log('masuk downloadAtch', certificationPath, filename)
		return new Promise(async (resolve, reject) => {
			try {
        let url = `${certificationPath}${filename}`;
        console.log('tempurl', filename);
        console.log('url', url);
    
        let getMime = filename.split('.')[1];
        let theMime = this.globalService.getMIMEtype(getMime);
    
        if (this.platform.is('cordova')) {
          const fileTransfer: FileTransferObject = this.transfer.create();
          const localPath = this.platform.is('android') ? cordova.file.externalCacheDirectory + `/${filename}` : cordova.file.cacheDirectory + `/${filename}`;
    
          fileTransfer.download(url, localPath)
            .then((entry) => {
              console.log('ENTRY', entry);
              switch (getMime) {
                case 'png':
                case 'jpg':
                  console.log('MASUK DEVICE IMAGE');
                  window.open(url,'_blank');
                  break;
                default:
                  console.log('MASUK DEVICE FILE');
                  this.fileOpener.open(entry.toURL(), theMime);
              }
            }, (error) => {
              console.log('ERROR HAPPEN', error);
            });
        } else {
          switch (getMime) {
            case 'png':
            case 'jpg':
            case 'txt':
              console.log('MASUK WINDOWS IMAGE');
              window.open(url);
              break;
            default:
              console.log('MASUK WINDOWS FILE');
              window.location.href = url;
          }
        }
				resolve();
			} catch (error) {
				reject(error)
			}
		})
  }
  
  updatePost(fileName, requestNo) {
    console.log('updatePost', fileName, requestNo)
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.certificationSf6Api.updatePost({fileName: fileName, requestNo: requestNo})
          .subscribe((result) => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  // downloadPdf(trneventCode): Observable<any> {
  //   return this.certificationSf6Api.downloadPdf(trneventCode); 
  // }

  generatePdf(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadPdfBlob(data, 'Certificate')
    } else {
      saveAs(data, 'Certificate.pdf')
    }
  }

  checkCertification(data): Observable<any> {
		return this.certificationSf6Api.checkCertification(data);
	}
}


// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-certification/profile-certification.bloc.ts